import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Draws the About-page journey line left-to-right as the section scrolls
 * through the viewport (clip-path wipe tied to scroll progress).
 * @param {HTMLElement} section
 */
function bindJourneyLine(section) {
	const paths = section.querySelector('.about-journey__paths');
	if (!paths) {
		return null;
	}

	gsap.set(paths, { clipPath: 'inset(0px 100% 0px 0px)' });

	const tween = gsap.to(paths, {
		clipPath: 'inset(0px 0% 0px 0px)',
		ease: 'none',
		scrollTrigger: {
			trigger: section,
			start: 'top 75%',
			end: 'bottom 80%',
			scrub: 0.5,
		},
	});

	return () => {
		tween.scrollTrigger?.kill();
		tween.kill();
		gsap.set(paths, { clearProps: 'clipPath' });
	};
}

export function initAboutJourneyLineDraw() {
	const sections = document.querySelectorAll('.js-about-journey');
	if (!sections.length) {
		return;
	}

	const cleanups = [];

	gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
		sections.forEach((section) => {
			const cleanup = bindJourneyLine(section);
			if (cleanup) {
				cleanups.push(cleanup);
			}
		});

		return () => cleanups.forEach((fn) => fn());
	});
}
